import type { IDElement } from "../IDElement";
import type { ReportConfiguration } from "./reportConfiguration";

export type CertificateConfiguration = ReportConfiguration & {
  data: {
    starts_at: string | null;
    ends_at: string | null;
    uek_modules: UeKModule[];
    technical_education: TechnicalEducation[];
    project_details: ProjectDetails;
    project: boolean;
    first_signature: number;
    second_signature: number;
  };
};

export type UeKModule = IDElement & {
  num: number | null;
  name: string;
};

export type TechnicalEducation = IDElement & {
  title: string;
  details: string;
};

export type ProjectDetails = {
  subject: Subject[];
  total_max_points: number | null;
};

export type Subject = IDElement & {
  title: string;
  max_points: number | null;
};

export const emptyProjectDetails: ProjectDetails = {
  subject: [],
  total_max_points: null,
};

export const emptySubject: Omit<Subject, "id"> = { title: "", max_points: null };

export const emptyTechnicalEducation: Omit<TechnicalEducation, "id"> = { details: "", title: "" };

export const emptyUeKModule: Omit<UeKModule, "id"> = { name: "", num: null };
